<template>
  <div>
  <b-row>
    <b-col sm="4">
      <b-card>
      <p>Row colors:</p>
      <b-form-input class="range-slider" v-model="blackRows" type="range" min="0" :max=pageConfig.rows></b-form-input>
      <div class="mt-2">Black: {{ blackRows }} White: {{ pageConfig.rows-blackRows }}</div>
      <b-row align-h="between">
      <b-button class="pdf-btn" pill :disabled="isPDFGenerating" variant="success" @click="GeneratePDF()">Generate PDF</b-button>
      <b-button class="pdf-btn" pill variant="success" :disabled="!isPDFGenerated" @click="OutputPDF(PdfDoc)">Load last PDF</b-button>
      </b-row>
    </b-card>
    </b-col>
    <b-col>
      <b-card class="pdf-preview">
        <h3 class="text-center" >PDF Preview</h3>
        <div class="pdf-grid" :style="`grid-template-columns: repeat(auto-fill, calc((100%  / ${pageConfig.cols} ))`">
          <div class="cell-preview" v-for="(c, idx) in cells" 
          :key="`cell${idx}`"
          :class="{ black_cell: c.isBlack }"
          >
            <!-- {{c}}  Cell object for debuging -->
          </div>
        </div>
        <!-- <b-row v-for="y in pageConfig.cols" :key="`${y}`">
          <b-col v-for="x in pageConfig.rows" :key="`${x}.${y}`" >
            <div class="border border-primary"> {{ `NR.PK:${(pageConfig.cols)*(y-1)+(x-1)} col:${y} row:${x}` }}</div>
          </b-col>
        </b-row> -->
      </b-card>
    </b-col>
  </b-row>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import { jsPDF } from 'jspdf';
import Services from '@/services/index';
import IdToHrHex from '@/shared/IdToHrHex';

export default {
  data() {
    return {

      //                             //
      //  All Mesuremnets are in mm  //
      //                             //

      pageConfig: {
        PageMarginTop: 10, // Page margin from top //
        PageMarginRight: 10, // Page margin from right
        cols: 5, // Cell column count
        rows: 13, // Cell row count
        CellWidth: 38, // Width of cell
        CellHeight: 21.2, // Height of cell
      },
      blackRows: 4, // Black cell row count
      uids: [], // UIds from DB  [{id:3},{id:4},{id:7}]
      // cellCoords: [], // Cell Coordinates on page, cells get rendered from top left to bottom right
      // Define the colours of the QR code 'dark' is the background, 'ļight' is the primary code

      QRCodeBaseURL: window.ENV.VUE_APP_DOMAIN_NAME, // Base URL of current ENV
      QRCodeDataURL: '', // Final URL that will be in QR code
      QRWidth: 19, // Width of QR code
      QRHeight: 19, // Height of QR code
      RelQRX: 1, // QR code relative x position to cell
      RelQRY: 1, // QR code relative y position to cell
      QrOpts: {}, // QR options that will be passed to QRCode renderer

      RelHrQrX: 25, // Human readable QR code relative x postion to cell
      RelHrQrY: 19, // Human readable QR code relative y postion to cell

      PrintDate: '', // Date text
      RelDateX: 28, // Date text relative x position to cell
      RelDateY: 16.5, // Date text relative y position to cell

      TextAlignment: { // Configuration paramater that uses JsPDF to align text
        angle: 90, // Uses degrees to determine text angle
      },
      ENVName: window.ENV.VUE_APP_ENV_NAME, // Base URL of current ENV
      RelEnvX: 34.5, // Environment name text relative x postion to cell
      RelEnvY: 18.5, // Environment name text relative y postion to cell

      isPDFGenerated: false,
      isPDFGenerating: false,
    };
  },
  computed: {
    cellCount() { return this.pageConfig.cols * this.pageConfig.rows; },
    cells() { return [...new Array(this.cellCount)].map((e, idx) => (this.getCellInfo({ idx }))); },
    cellCoords() {
      const Coords = [];
      for (let y = this.pageConfig.PageMarginTop; y <= this.pageConfig.CellHeight * this.pageConfig.rows; y += this.pageConfig.CellHeight) {
        for (let x = this.pageConfig.PageMarginRight; x <= this.pageConfig.CellWidth * this.pageConfig.cols; x += this.pageConfig.CellWidth) {
          Coords.push({ x: x, y: y });
        }
      }
      return Coords;
    },
  },

  mounted() {
  },

  methods: {
    getQrOptsInverted(inverted) {
      const QrOpts = {
        errorCorrectionLevel: 'H',
        // Error resistance. Lower resistence incresses capacity, 
        // but lowers readability from damage.
        // Possible values: 'L', 'M', 'Q', 'H' 
        type: 'image/jpeg',
        // Output type choices: 'image/png', 'image/jpeg', 'image/webp'
        quality: 0.92,
        // A Number between 0 and 1 indicating image quality if the requested type is image/jpeg or image/webp
        margin: 1,
        // Define the margin in mm around the QR code.
        color: {
          dark: inverted ? '#00000000' : '#FFFFFFFF',
          light: inverted ? '#FFFFFFFF' : '#00000000',
        }
      };
      return QrOpts;
    },

    getCellInfo({ idx }) {
      const id = this.uids[idx] ? this.uids[idx].id : null;
      return {
        id,
        x: this.cellCoords[idx].x,
        y: this.cellCoords[idx].y,
        isBlack: idx / this.pageConfig.cols < this.blackRows,
        printed_at: '',
      };
    },
    GenerateQRCode(qrCodeBaseURL, qrOpts) {
      QRCode.toDataURL(qrCodeBaseURL, qrOpts, (err, url) => {
        if (err) throw err;
        this.QRCodeDataURL = url;
      });
    },

    GenerateUIDs() {
      const uniqueIdsRequestData = { UidCount: this.cellCount };
      return Promise.resolve(Services.uniqueIds.bulkCreate(uniqueIdsRequestData).then((uniqueIds) => {
        let index = 0;
        for (const cell of this.cells) {
          cell.id = uniqueIds.data.data[index].id;
          cell.printed_at = uniqueIds.data.data[index].printed_at;
          index++;
        }
      }));
    },

    OutputPDF(doc) {
      doc.output('dataurlnewwindow');
    },

    GeneratePdfContent() {
      const doc = new jsPDF('portrait', 'mm', ['210', '297']); // Rotation, Page mesurement, Default A4 sheet of paper dimensions

      // Debug text warning of wrong printer settings
      doc.setFontSize(6);
      doc.text('Ja skaidri redzi šo tekstu, tad printeru mērogs iestatīts nepareizi - jābūt ietilpināt drukājamā apgabalā', 0, 3);

      for (const cell of this.cells) {
        if (cell.isBlack) {
        // Black background White QR code and text
          doc.setFillColor(0, 0, 0); // Format RGB
          doc.setTextColor('#FFFFFF');
          this.QrOpts = this.getQrOptsInverted(false);
        } else {
        // White background Black QR code and text
          doc.setFillColor(255, 255, 255);
          doc.setTextColor('#000000');
          this.QrOpts = this.getQrOptsInverted(true);
        }

        // Adding cell to PDF
        doc.rect(cell.x, cell.y, this.pageConfig.CellWidth, this.pageConfig.CellHeight, 'F'); // 'F' to fill, 'S' for grid.

        // Generating Human Readable Uinique IDs from ID -> XXXX-XXXX where X is hex number
        const UIdHr = IdToHrHex(cell.id); 

        // Generating QR Code from QRCodeBaseURL + resource path + UIdHr
        this.GenerateQRCode((`${this.QRCodeBaseURL}#/r/${UIdHr}`), this.QrOpts);

        // Adding QR Code to PDF as image of QRCodeDataURL
        doc.addImage(this.QRCodeDataURL, 'JPEG', (cell.x + this.RelQRX), (cell.y + this.RelQRY), this.QRWidth, this.QRHeight);

        // Adding Human readable UID to PDF
        doc.setFontSize(10);
        doc.text(UIdHr, (cell.x + this.RelHrQrX), (cell.y + this.RelHrQrY), this.TextAlignment);

        this.PrintDate = cell.printed_at.slice(0, 10);

        // Adding Date QR Code is printed to PDF
        doc.setFontSize(6);
        doc.text(this.PrintDate, (cell.x + this.RelDateX), (cell.y + this.RelDateY), this.TextAlignment);

        // Adding ENV name to PDF
        doc.setFontSize(18);
        doc.text(this.ENVName, (cell.x + this.RelEnvX), (cell.y + this.RelEnvY), this.TextAlignment);
      }
      this.PdfDoc = doc;
      this.isPDFGenerated = true;
      this.isPDFGenerating = false;
    },
    GeneratePDF() {
      this.isPDFGenerating = true;
      this.GenerateUIDs().then(() => {
        this.GeneratePdfContent();
        this.OutputPDF(this.PdfDoc);
      }).catch(({ errors, message }) => {  
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.pdf-preview{
background-color: #d6d2d2;
}
.pdf-grid {
  display: grid;
}

.cell-preview{
  padding-top: 45px;
  padding-right: 60px;
  border:solid 1px black;
  background-color: white;
}

.black_cell{
  background-color: black;
  border:solid 1px white;
}

.pdf-btn{
  margin-right: 10px;
  margin-left: 10px;
}
</style>
